export default "__VITE_ASSET__DlcZDbjP__"